module.exports = __webpack_public_path__ + "img/sdg_en_(7).f6c2ed8e.png";